import React, { useEffect } from 'react'

import ScreenLoader from '@/components/ScreenLoader'
import AdminFishImporter from '@/components/AdminFishImporter/AdminFishImporter'
import { urlQuery } from '@/lib'
import { request } from '@/lib/axios'
import { useUserInfo } from '@/models/User'
import { useStore } from '@/store'
import dayjs from 'dayjs'

type Props = {
  children: React.ReactNode
}

const MainLayout: React.FC<Props> = ({ children }) => {
  const { updateState } = useStore()
  const userInfo = useUserInfo()

  useEffect(() => {
    const garena_token =
      urlQuery('garena_token') ||
      urlQuery('access_token') ||
      urlQuery('encodeparam')
    // let clientLogged = localStorage.getItem('garena_token')
    const checkString =
      garena_token +
      dayjs().format('DD-MM-YYYY-mm') +
      import.meta.env.VITE_APP_PROJECT_NAME

    // if(garena_token && checkString != clientLogged && garena_token.length >= 64) {
    if (garena_token) {
      request
        .get(
          `${window.location.origin}/connect/garena/callback?${garena_token.length > 70 ? 'garena_token' : 'access_token'}=${garena_token}&source_type=ingame`,
        )
        .then(() => {
          updateState('loginSuccess', true)
          localStorage.setItem('garena_token', checkString)
          // if(response.status == 'success') {
          //   updateState('loginSuccess', true)
          //   localStorage.setItem('garena_token', checkString)
          //   // window.location.reload()
          // }
        })
    }
  }, [updateState])

  return (
    <>
      {/* <div className={style.snowOverlay}>
        <PixelSnow />
      </div> */}
      {/* <RotateNotice /> */}
      <ScreenLoader />
      {userInfo?.user?.isAdmin === true && <AdminFishImporter />}
      <section id="main-body">{children}</section>
    </>
  )
}

export default MainLayout
